// removed by extract-text-webpack-plugin
module.exports = {"main":"_11Xg7qSt","icons":"_1YoI0UAC","opacity-change":"_3dqMm8xR","one":"_1925E6Sr","two":"_1ZKfUxe-","no-background":"_1AiHdcAF"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/Loading/Loading.styl
// module id = 371
// module chunks = 0